import "bootstrap/dist/css/bootstrap.css"
import "font-awesome/css/font-awesome.css"

import "./src/styles/global.scss"
